import { useQuery } from '@tanstack/react-query';
import bookingServices from '../services/booking.service';

export const useBooking = (bookingId) => {
  return useQuery({
    queryKey: ['booking', bookingId],
    queryFn: () => bookingServices.getBookingById(bookingId),
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!bookingId,
  });
};
